import React from 'react';
import Header from 'cccisd-header';
import { CV_URL } from '../../pages/Welcome';
import style from './style.css';

const Fortress = window.cccisd.fortress;
const AppDefs = window.cccisd.appDefs;

export default props => {
    const { hideSecondaryNav } = props;
    const wpUrl = window.cccisd.env.wpUrl || 'https://wp.share.3cimpact.com';
    const primaryNavLinks = [
        { url: CV_URL, label: 'Return to Centervention' },
        { url: '/help', label: 'SHARE Help Center' },
        { url: wpUrl + '/contact', label: 'Contact' },
    ];

    if (Fortress?.user?.pawns?.length > 1) {
        primaryNavLinks.unshift({ url: '/my-account', label: 'My Account' });
    }

    const showLearnLogo = () => {
        const currentPath = window.location.pathname;
        const currentRoute = AppDefs.routes.find(route => route.url.startsWith(currentPath));

        if (currentRoute && currentRoute.showLearnLogo) {
            const helpIndex = primaryNavLinks.findIndex(link => link.url === '/help');
            if (helpIndex !== -1) {
                primaryNavLinks.splice(helpIndex, 1);
            }

            return true;
        }

        return false;
    };

    const learnLogo = showLearnLogo();

    return (
        <div>
            <Header
                containerClassName="container-fluid"
                wrapperClassName={style.wrapper}
                logoClassName={learnLogo ? style.learnLogo : style.logo}
                primaryNavLinks={primaryNavLinks}
                secondaryNavLinks={hideSecondaryNav ? '' : 'header'}
                showHomeAction={false}
                showAlertAction={learnLogo ? false : true}
                showAdminAction={Fortress.hasRole('uberadmin')}
            />
        </div>
    );
};
